import { AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useInfiniteQuery } from '@tanstack/react-query';
import { IThreeDImageListItem } from '@types';

// 3D 소재 Output 페이지 이미지 리스트 불러오기
async function getThreeDImageList(params: {
  pageParam: number;
  query: string;
}): Promise<AxiosResponse<FetchResult<IThreeDImageListItem[]>>> {
  const response = await instance.get(`/assets-3d?page=${params.pageParam}${params.query}`);
  return response;
}

interface UseFetchThreeDImageListCallbacks {
  onSuccess?: (data: any, variables: { pageParam: number; query: string }, context: unknown) => void;
}

const useFetchThreeDImageList = (query: string, callbacks?: UseFetchThreeDImageListCallbacks) => {
  const {
    data,
    fetchNextPage,
    fetchPreviousPage,
    hasNextPage,
    hasPreviousPage,
    isFetchingNextPage,
    isFetchingPreviousPage,
    promise,
    isLoading,
    isFetching,
    ...result
  } = useInfiniteQuery({
    queryKey: ['get', `/assets-3d/${query}`],
    queryFn: async (context) => {
      const response = await getThreeDImageList({
        pageParam: context.pageParam,
        query
      });

      // pageParam이 1일 때 최상단 스크롤업을 위한 콜백 실행
      if (context.pageParam === 1 && callbacks?.onSuccess) {
        callbacks.onSuccess(response, { pageParam: context.pageParam, query }, context);
      }

      return response;
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => {
      if (lastPage.data.meta && lastPage.data.meta.hasNextPage) {
        return lastPage.data.meta.page + 1;
      } else {
        return null;
      }
    },
    retry: false,
    refetchOnWindowFocus: false
  });

  return {
    data,
    fetchNextPage,
    fetchPreviousPage,
    hasNextPage,
    hasPreviousPage,
    isFetchingNextPage,
    isFetchingPreviousPage,
    promise,
    isLoading,
    isFetching,
    ...result
  };
};

export default useFetchThreeDImageList;
